import { ApiProperty } from "@nestjs/swagger";


export class ActivatePermDto{
    @ApiProperty()
    id:number;
}